import React, { useRef } from 'react';

import { useDateField } from '@react-aria/datepicker';
import { useLocale } from '@react-aria/i18n';

import { useTimeFieldState } from '@react-stately/datepicker';
import type { TimePickerProps, TimeValue } from '@react-types/datepicker';

import { DatePickerContainer } from '../date-picker-container';
import { DatePickerInput } from '../date-picker-input';
import { DatePickerSegment } from '../date-picker-segment';

export interface IProps extends TimePickerProps<TimeValue> {
  isQuiet?: boolean;
}

export const TimeField: React.FC<IProps> = (props) => {
  const { autoFocus, isDisabled, isReadOnly, isRequired, isQuiet } = props;

  const ref = useRef(null);
  const { locale } = useLocale();

  const state = useTimeFieldState({
    ...props,
    locale
  });
  const { labelProps, fieldProps, descriptionProps, errorMessageProps } = useDateField(
    props,
    state,
    ref
  );

  const segments = React.useMemo(() => {
    return state.segments.map((segment, i) => (
      <DatePickerSegment
        key={i}
        isDisabled={isDisabled}
        isReadOnly={isReadOnly}
        isRequired={isRequired}
        segment={segment}
        state={state}
      />
    ));
  }, [state.segments]);

  return (
    <DatePickerContainer
      {...props}
      labelProps={labelProps}
      descriptionProps={descriptionProps}
      errorMessageProps={errorMessageProps}
      validationState={state.validationState}
    >
      <DatePickerInput
        fieldProps={fieldProps}
        isDisabled={isDisabled}
        isQuiet={isQuiet}
        autoFocus={autoFocus}
        validationState={state.validationState}
        inputRef={ref}
      >
        {segments}
      </DatePickerInput>
    </DatePickerContainer>
  );
};
